// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"fa045fea","240":"e7a0b4a6","262":"ecd6ea94","288":"7fa9227e","325":"58ba5392","389":"39d530b8","477":"2a0054e7","576":"0853568e","802":"b795303d","858":"8c8ed9ca","920":"3eaefdef","940":"5adbd61e"}[chunkId] + ".chunk.js";
};